import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'admin-view-information-dialog',
  templateUrl: './view-information-dialog.component.html',
  styleUrls: ['./view-information-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ViewInformationDialogComponent {
  data = inject<{
    translationPrefix: string;
  }>(MAT_DIALOG_DATA);
  private dialogRef = inject<MatDialogRef<ViewInformationDialogComponent>>(MatDialogRef);

  public closeDialog(): void {
    this.dialogRef.close();
  }
}
